module.exports = __webpack_public_path__ + "static/media/actionOverview-14@3x.f578f6af.png";